import { Route, Switch } from 'react-router-dom';
import Loader from '__components/Kizen/Loader';
import { useCatalogDetailPage } from './context';

export const CatalogDetail = () => {
  const ctx = useCatalogDetailPage();
  const { isLoading } = ctx.query;
  const { subroutes } = ctx;

  return (
    <Loader loading={isLoading}>
      <Switch>
        {subroutes.map(({ component: Component, path, routePath, exact }) => (
          <Route
            key={path}
            path={routePath}
            exact={exact}
            render={() => <Component />}
          />
        ))}
      </Switch>
    </Loader>
  );
};
